"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pagination_1 = require("@csod/pagination");
exports.Pagination = pagination_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Pagination"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/Pagination/Pagination.js
// module id = 770
// module chunks = 0